import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import '../src/Assets/Styles/Styles.css';
import '../src/Assets/Styles/Styles-en.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from "react-i18next";
import i18n from "i18n";

// 🧩 Redux + React Query imports
import { Provider } from 'react-redux';
import store from './store/store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// 🧠 Create a React Query client instance
const queryClient = new QueryClient();

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const root = createRoot(rootElement);

const Main = () => {
    return (
        <Provider store={store}>
            <QueryClientProvider client={queryClient}>
                <I18nextProvider i18n={i18n}>
                    <BrowserRouter basename={baseUrl}>
                        <App />
                    </BrowserRouter>
                </I18nextProvider>
            </QueryClientProvider>
        </Provider>
    );
};

root.render(<Main />);

serviceWorkerRegistration.unregister();
reportWebVitals();
